<template>
  <div class="BankAccount">
    <h1 class="gl_form-title small mb-5">
      {{ t('hiring.common.bank-info.form-legend') }}
    </h1>

    <CardInfoComponent
      v-if="message && showMessage"
      :icon="message.icon"
    >
      {{ message.label }}
    </CardInfoComponent>

    <BankAccountNumber
      id="bank-account"
      v-model="iban"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue'
import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'
import BankDetails from '@/modules/common/hiring/models/APP/BankDetails'

import BankAccountNumber from '@/modules/core/components/formFields/BankAccountNumber.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineExpose({ triggerSubmit })
const loadingStore = useLoadingStore()

interface PropsInterface {
  nextForm: String[]
  answers: Record<string, any>
  configurations: Record<string, any>
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const iban = ref(props.answers.bankDetails.iban)
const message = computed(() => props.configurations?.tags?.bankCopayAlert ?? '')
const showMessage = computed(() => {
  const productCopayType = props.answers.product.copayType
  const { high, low } = props.configurations.copaymentTypes
  const validCopayTypes = [high.id, low.id]

  return validCopayTypes.includes(productCopayType)
})

function triggerSubmit() {
  const page = props.nextForm[0]

  const answers = {
    bankDetails: new BankDetails({
      iban: iban.value
    })
  }

  return { page, answers }
}

function beforeMount() {
  setTimeout(loadingStore.stopLoading, 300)
}

onBeforeMount(beforeMount)
</script>

<style lang="scss" scoped>
.BankAccount {
  .grid-inputs {
    display: grid;
    align-items: flex-start;
    grid-template-columns: 4.5rem 1fr;
    gap: $gap-l;
  }

  .label {
    font-family: $font-family-primary;
    font-size: $font-size-m;
    font-style: normal;
    font-weight: $font-weight-400;
    line-height: $line-height-100p;
    color: $color-neutral-dark;
    margin-bottom: $spacing-s;
  }
}
</style>
